<form class="search-box position-relative" (submit)="false">
    <i class="material-symbols-outlined">
        search
    </i>
    <input
        type="text"
        class="input-search d-block w-100 border-none outline-0"
        [placeholder]="placeholder"
        (input)="onSearch($event)" 
        #input
    />
</form>
